import React from 'react'

import "./aboutAnantLadha.css"

import anantLadha from "../../assets/anantLadha.png";

import BackBtn from "../../assets/backBtn.png";

import dashedHorizontal from "../../assets/dashedPattern.png"

import aboutAnanth from "../../assets/aboutAnanth.png"

import { Link } from "react-router-dom" 



const AboutAnantLadha = () => {
  return (
    <div className="about-container">
      <div className="about-heading">
       <Link to={'/'}><img className="backBtn" src={BackBtn} /></Link>
        <div className="heading-about">ABOUT CLASSPLUS</div>
      </div>

      <div className="about-section">
        <div className="about-left">
          <img src={anantLadha} className="celebrityImage" />
        </div>

        <div className="about-right">

            <img src={aboutAnanth} className='aboutAnant-content'/>
        </div>
      </div>
      <img src={dashedHorizontal} className="dashedHorizontal"/>
    </div>
  )
}

export default AboutAnantLadha